import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { isset } from "legacy/helpers.es6"
import StarRating from "legacy/marinascom-review/StarRating"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally, not via an import

class ReviewForm extends React.Component {
  constructor(props) {
    super(props)

    this.setReview = this.setReview.bind(this)
    this.submitReview = this.submitReview.bind(this)
    this.activeCaptainAccount = this.activeCaptainAccount.bind(this)
    this.handleValidationUpdate = this.handleValidationUpdate.bind(this)
    this.validator = new ReactValidator()
  }

  submitReview() {
    Amplitude.trackEvent("reviews:submit_a_review_pressed", {
      reservation_id: this.props.reservationID,
      marina_id: this.props.marinaId,
      user_id: this.props.userId,
    })

    this.validator.displayErrors()
    this.forceUpdate()
    if (this.validator.allValid()) {
      this.props.setParentState({ processing: true })
      this.props.ajaxSubmit()
    }
  }

  setReview(event) {
    this.props.setParentState({ review: event.target.value })
  }

  activeCaptainAccount() {
    if (isset(this.props.state.email)) {
      return (
        <div>
          <p>
            A Marinas.com review will be submitted under{" "}
            <span className="text-success b">{this.props.state.email}</span>
          </p>
        </div>
      )
    }
    return null
  }

  handleValidationUpdate() {
    delete this.validator.fields.checkbox
    delete this.validator.fields.username
    delete this.validator.fields.password
  }

  render() {
    return (
      <div>
        <h3>Review {this.props.marinaName}</h3>
        <hr />
        <h4 className="text-center">
          You stayed at <strong>{this.props.state.marinaName}</strong> on{" "}
          <strong>{this.props.state.tripDate}</strong>.
        </h4>
        <h4 className="text-center">How was your stay?</h4>
        <StarRating
          setParentState={this.props.setParentState}
          state={this.props.state}
        />
        <p className="text-center">
          {this.validator.message(
            "starValue",
            this.props.state.starValue,
            "required"
          )}
        </p>
        <hr />
        <h4 className="center">Please tell us more.</h4>
        <div className="form-group">
          <label htmlFor="yourReview">Your review</label>
          <textarea
            className="form-control"
            id="yourReview"
            name="review"
            rows="4"
            value={this.props.state.review || ""}
            onChange={this.setReview}
          />
          {this.validator.message(
            "review",
            this.props.state.review,
            "required|min:20"
          )}
        </div>
        <hr />
        {this.activeCaptainAccount()}
        <NextButton
          processing={this.props.state.processing}
          click={this.submitReview}
          icon=""
          text="Submit Review"
          processingText="Submitting Review..."
        />
        {this.validator.customMessage(this.props.state.submitError)}
      </div>
    )
  }
}

ReviewForm.propTypes = {
  setParentState: PropTypes.func.isRequired,
  state: PropTypes.shape({
    marinaName: PropTypes.string.isRequired,
    tripDate: PropTypes.string.isRequired,
    starValue: PropTypes.number,
    review: PropTypes.string,
    processing: PropTypes.bool,
    submitError: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  ajaxSubmit: PropTypes.func.isRequired,
  marinaName: PropTypes.string.isRequired,
  reservationID: PropTypes.string,
  marinaId: PropTypes.string,
  userId: PropTypes.string,
}

export default ReviewForm
